import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = { class: "banner-grid__overlay-container" }
const _hoisted_3 = ["innerHTML"]

import { computed } from 'vue';
import useBanners from '@/composables/useBanners';

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'BannerGrid',
  props: {
  block: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props



const bannersPerRow = computed(() => {
  const bpr = props.block.fields.BannersPerRow?.value;
  return bpr ? `_bannerGrid-container${bpr}` : '';
});

const { banners } = useBanners(props.block.fields.Banners, 'banner-grid');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['_bannerGrid-container', _unref(bannersPerRow)])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(banners), (banner) => {
      return (_openBlock(), _createElementBlock("div", {
        key: banner.key,
        class: "_bannerGrid-itemContainer"
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(banner.element), {
          to: banner.link,
          class: "_bannerGrid-item",
          style: _normalizeStyle(banner.aspectRatio)
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              class: "_bannerGrid-itemImage",
              src: banner.imageUrl,
              alt: banner.alt
            }, null, 8, _hoisted_1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(banner.overlayClasses, (position) => {
              return (_openBlock(), _createElementBlock("div", {
                key: position,
                class: _normalizeClass([`banner-grid__overlay--${position.name}`, 'banner-grid__overlay'])
              }, [
                _createElementVNode("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(position.items, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item,
                      innerHTML: banner.body,
                      class: _normalizeClass(item)
                    }, null, 10, _hoisted_3))
                  }), 128))
                ])
              ], 2))
            }), 128))
          ]),
          _: 2
        }, 1032, ["to", "style"]))
      ]))
    }), 128))
  ], 2))
}
}

})